import React from 'react'
import DeploymentListCard from '@/components/DeploymentListCard'

export default function OrganizationDeployments() {
    return <DeploymentListCard />
}
